import { render, staticRenderFns } from "./AuditData.vue?vue&type=template&id=c5942aa0&scoped=true"
import script from "./AuditData.vue?vue&type=script&lang=js"
export * from "./AuditData.vue?vue&type=script&lang=js"
import style0 from "./AuditData.vue?vue&type=style&index=0&id=c5942aa0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5942aa0",
  null
  
)

export default component.exports